import { observer } from 'mobx-react'
import classnames from 'classnames'
import React from 'react'
import { Portal } from 'react-portal'
import { Helmet } from 'react-helmet'
import { AppStyles } from './app.style'
import { withStyles, WithStyles } from '@material-ui/styles'
import favIcon from '../../favicons/favicon.ico'
import webManifest from '../../favicons/site.webmanifest'
import { contentStore } from 'stores/contentStore/contentStore'
import { callToScrollStore } from 'projects/danioth/stores/callToScrollStore'
import scrollMouse from '../../icons/scrollMouse.svg'
import scrollFinger from '../../icons/scrollFinger.svg'
import { breakpoints } from 'stores/breakpointsStore'

type DefaultProps = WithStyles<typeof AppStyles>

@observer
class Default extends React.Component<DefaultProps> {
  render() {
    let seoDescription = ''
    let seoTitle = ''
    if (contentStore.uiElements && contentStore.uiElements) {
      seoDescription = contentStore.uiElements.SEODescription
      seoTitle = contentStore.uiElements.SEOTitle
    }

    const { classes } = this.props

    const scrollIcon = !breakpoints.desktop ? scrollFinger : scrollMouse
    const callToScrollIcon: JSX.Element = (
      <div
        className={classnames(classes['call-to-scroll-container'], {
          [classes['invisible']]: !callToScrollStore.showIcon,
        })}
      >
        <div className={classnames(classes['inner-container'])}>
          <img src={scrollIcon} alt="scroll animation" />
          <div>{contentStore.uiElements?.idleTimePopupText}</div>
        </div>
      </div>
    )

    return (
      <React.Fragment>
        <Helmet>
          <link rel="shortcut icon" href={favIcon} />
          <link rel="manifest" id="manifest" href={webManifest} />
          <title>{seoTitle}</title>
          <meta name="description" content={seoDescription} />
        </Helmet>
        <Portal>{callToScrollIcon}</Portal>
      </React.Fragment>
    )
  }
}

export default withStyles(AppStyles)(Default)
